import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { LogoWrapper, StyledDiv, TitleWrapper } from "src/app/pages/LoginPage/styles/LoginStyle";
import { TitleLogin } from "src/app/pages/LoginPage/styles/TitleLoginStyle";
import { Logo } from "../../../components";
import { ActionBar } from "../../../components/ActionBar/ActionBar";
import { PrimaryButton } from "../../../components/Buttons/components/ActionButton";
import { Logos, LogoSize } from "../../../components/Logo/Logo";
import { MS_ENTRA_LOGIN_ERROR_KEY } from "../../../core/router/auth/completeMsEntraLogin";
import { Palette } from "../../../core/styles/palette";

export const ApaMSELoginPage = () => {
    const { t } = useTranslation();
    const { instance } = useMsal();
    const [error, setError] = useState<string>();

    // loginRedirect leaves and reloads the page; if the redirect came back with a login failure,
    // msalConfig's bootstrap handling stashes the message here since this component wasn't mounted
    // to receive it directly.
    useEffect(() => {
        const redirectError = sessionStorage.getItem(MS_ENTRA_LOGIN_ERROR_KEY);
        if (redirectError) {
            sessionStorage.removeItem(MS_ENTRA_LOGIN_ERROR_KEY);
            setError(redirectError);
        }
    }, []);

    const handleMicrosoftLogin = async () => {
        setError(undefined);

        try {
            await instance.loginRedirect({
                scopes: ["User.Read openid profile offline_access"],
            });
        } catch (err) {
            setError((err as Error)?.message || "Microsoft login failed");
        }
    };

    return (
        <StyledDiv data-name="login_form">
            <LogoWrapper>
                <Logo src={Logos.AeviLogoRebrand} size={LogoSize.REGULAR} />
            </LogoWrapper>
            <TitleWrapper>
                <TitleLogin>{`${t("page.title.login")}`}</TitleLogin>
            </TitleWrapper>
            <ActionBar>
                <PrimaryButton name="submit" htmlType="submit" onClick={handleMicrosoftLogin}>
                    {`${t("button.submit")}`}
                </PrimaryButton>
            </ActionBar>

            {error && (
                <LoginErrorContainer>
                    <LoginErrorText>{error}</LoginErrorText>
                </LoginErrorContainer>
            )}
        </StyledDiv>
    );
};

export default ApaMSELoginPage;

export const LoginErrorContainer = styled.div`
    margin-top: 16px;
    padding: 12px;
    background-color: ${Palette.PalePink};
    border: 1px solid ${Palette.LightPink};
    border-radius: 4px;
`;

export const LoginErrorText = styled.div`
    font-family: "RobotoRegular", sans-serif;
    color: ${Palette.AeviRed};
`;
